var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0832 3.29028C19.0711 2.63788 5.81562 2.59364 5.777 3.3836C5.57268 7.53932 5.63301 20.4457 5.75126 22.415C5.79953 23.221 18.1637 22.5445 19.191 22.1133C19.598 21.9428 19.1355 6.08409 19.0832 3.29028Z",
    fill: "#3C4E7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1616 3.75199C18.1471 3.14223 6.69756 3.00306 6.66779 3.74234C6.50932 7.62858 6.62838 19.7008 6.74341 21.5445C6.79007 22.2991 17.3467 21.6829 18.2477 21.2847C18.604 21.1262 18.2219 6.36561 18.1616 3.75199Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27812 7.01172L7.51318 7.05838L7.55984 8.82331L9.32478 8.77665L9.27812 7.01172Z",
    fill: "#791186"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44951 12.1396L7.68457 12.1863L7.73203 13.9512L9.49697 13.9046L9.44951 12.1396Z",
    fill: "#F9E9D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29765 9.56494L7.53271 9.6124L7.57937 11.3773L9.34431 11.3307L9.29765 9.56494Z",
    fill: "#F9E9D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46935 14.6943L7.70361 14.741L7.75108 16.5059L9.51601 16.4593L9.46935 14.6943Z",
    fill: "#F9E9D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66801 17.543L7.90308 17.5896L7.94973 19.3546L9.71467 19.3079L9.66801 17.543Z",
    fill: "#F9E9D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58059 8.75436C8.55887 8.71816 8.52911 8.66588 8.5098 8.6168C8.41246 8.37306 8.32719 8.00865 8.2741 7.78099C8.25721 7.7094 8.18561 7.66516 8.11002 7.68205C8.04242 7.69894 7.99818 7.77054 8.01507 7.84213C8.09149 8.16793 8.23629 8.75195 8.3827 8.94502C8.46153 9.04879 8.55324 9.07372 8.63207 9.0504C8.65701 9.04316 8.68919 9.02626 8.72378 8.99409C8.764 8.95708 8.81629 8.8887 8.87582 8.79619C9.17266 8.33203 9.70761 7.17928 10.0052 6.53894C10.0358 6.47217 10.0069 6.39334 9.94089 6.36277C9.87413 6.3322 9.79529 6.36116 9.76472 6.42713C9.50811 6.98138 9.0713 7.92258 8.76963 8.45672C8.70286 8.57497 8.64253 8.67312 8.59346 8.73988C8.58863 8.74471 8.58461 8.74954 8.58059 8.75436Z",
    fill: "#DF6550"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56277 11.2715C8.54105 11.2353 8.51128 11.183 8.49198 11.1339C8.39464 10.8901 8.30937 10.5257 8.25628 10.2981C8.23938 10.2265 8.16779 10.1822 8.09619 10.1991C8.0246 10.216 7.98035 10.2876 7.99725 10.3592C8.07367 10.685 8.21847 11.269 8.36488 11.4621C8.44371 11.5659 8.53542 11.5908 8.61425 11.5675C8.63919 11.5594 8.67137 11.5434 8.70596 11.5112C8.74618 11.4742 8.79847 11.4058 8.858 11.3133C9.15483 10.8491 9.68978 9.69636 9.98743 9.05603C10.018 8.98926 9.98904 8.91043 9.92307 8.87986C9.8563 8.84929 9.77747 8.87825 9.7469 8.94422C9.49028 9.49847 9.05347 10.4397 8.75181 10.9738C8.68504 11.0921 8.62471 11.1902 8.57564 11.257C8.57081 11.2618 8.56679 11.2666 8.56277 11.2715Z",
    fill: "#DF6550"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60183 16.3593C8.58011 16.3231 8.55035 16.2709 8.53104 16.2218C8.4337 15.978 8.34843 15.6136 8.29534 15.386C8.27845 15.3144 8.20685 15.2701 8.13526 15.287C8.06366 15.3039 8.01942 15.3755 8.03631 15.4471C8.11273 15.7729 8.25753 16.3569 8.40394 16.55C8.48277 16.6538 8.57448 16.6787 8.65331 16.6554C8.67825 16.6481 8.71043 16.6312 8.74502 16.5991C8.78524 16.5621 8.83753 16.4937 8.89706 16.4012C9.1939 15.937 9.72885 14.7843 10.0265 14.1100C10.0571 14.0772 10.0281 13.9983 9.96213 13.9678C9.89537 13.9372 9.81653 13.9661 9.78596 14.0321C9.52935 14.5856 9.09254 15.5276 8.79087 16.0617C8.7241 16.18 8.66377 16.2781 8.6147 16.3449C8.60987 16.3489 8.60585 16.3537 8.60183 16.3593Z",
    fill: "#DF6550"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78347 13.1226C8.76175 13.0864 8.73199 13.0342 8.71268 12.9851C8.61534 12.7413 8.53007 12.3769 8.47698 12.1493C8.46009 12.0777 8.38849 12.0334 8.3169 12.0503C8.2453 12.0672 8.20106 12.1388 8.21795 12.2104C8.29437 12.5362 8.43917 13.1202 8.58558 13.3133C8.66441 13.4171 8.75612 13.442 8.83495 13.4187C8.85909 13.4114 8.88885 13.3962 8.92023 13.3704C8.95964 13.3374 9.00952 13.2795 9.06583 13.1999C9.34014 12.8121 9.81476 11.8621 10.0778 11.3344C10.1108 11.2684 10.0834 11.1888 10.0183 11.1566C9.95232 11.1236 9.87268 11.151 9.8405 11.2161C9.61365 11.6706 9.22913 12.4437 8.95562 12.8853C8.89609 12.9787 8.8253 13.0704 8.78347 13.1226Z",
    fill: "#DF6550"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0093 7.98011C12.5867 7.85301 15.1641 7.72671 17.7415 7.59961L10.0093 7.98011Z",
    fill: "#F9E9D6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0093 7.98011C12.5867 7.85301 15.1641 7.72671 17.7415 7.59961",
    stroke: "#6F7E9D",
    strokeWidth: 0.309957,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0793 10.324C12.6568 10.1977 15.2342 10.0706 17.8116 9.94434L10.0793 10.324Z",
    fill: "#F9E9D6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0793 10.324C12.6568 10.1977 15.2342 10.0706 17.8116 9.94434",
    stroke: "#6F7E9D",
    strokeWidth: 0.309957,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1162 12.8836C12.6936 12.7573 15.271 12.6302 17.8485 12.5039L10.1162 12.8836Z",
    fill: "#F9E9D6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1162 12.8836C12.6936 12.7573 15.271 12.6302 17.8485 12.5039",
    stroke: "#6F7E9D",
    strokeWidth: 0.309957,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2268 15.4801C12.8042 15.3538 15.3816 15.2267 17.9591 15.0996L10.2268 15.4801Z",
    fill: "#F9E9D6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2268 15.4801C12.8042 15.3538 15.3816 15.2267 17.9591 15.0996",
    stroke: "#6F7E9D",
    strokeWidth: 0.309957,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3196 18.4259C12.897 18.2996 15.4744 18.1725 18.0518 18.0454L10.3196 18.4259Z",
    fill: "#F9E9D6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3196 18.4259C12.897 18.2996 15.4744 18.1725 18.0518 18.0454",
    stroke: "#6F7E9D",
    strokeWidth: 0.309957,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92253 4.40881C7.71409 4.40398 16.3513 4.4611 17.9176 4.30182C18.1404 4.27929 17.8114 3.828 17.266 3.6832C16.6795 3.52795 15.423 3.38958 15.2106 3.09757C15.1069 2.95519 15.0047 2.5232 14.7288 2.12581C14.1721 1.32379 13.4304 0.924787 12.4571 0.860432C11.7934 0.816188 11.0042 1.19588 10.5747 1.75416C10.0333 2.45805 10.0647 2.94795 9.89975 3.07264C9.75415 3.18284 7.81143 3.64942 7.33359 3.91247C6.99814 4.09588 6.85013 4.40961 6.92253 4.40881ZM12.4442 1.31494C12.8255 1.30448 13.1432 1.60615 13.1537 1.98745C13.1642 2.36875 12.8625 2.68651 12.4812 2.69696C12.0999 2.70742 11.7821 2.40576 11.7717 2.02445C11.7612 1.64315 12.0629 1.3254 12.4442 1.31494Z",
    fill: "#6F7E9D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3793 1.26931C10.6915 1.74393 10.4421 2.32875 10.3601 2.86531C10.3552 2.89588 10.3762 2.92404 10.4067 2.92886C10.4373 2.93369 10.4654 2.91277 10.4703 2.88221C10.5475 2.37058 10.7864 1.81391 11.442 1.36101C11.4678 1.34332 11.4734 1.30873 11.4565 1.28298C11.4396 1.25805 11.4042 1.25161 11.3793 1.26931Z",
    fill: "#F3F3F3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7913 1.25149C11.5862 1.37135 11.3207 1.5974 11.1252 1.83149C10.9909 1.99238 10.8895 2.15729 10.8589 2.29645C10.8525 2.32622 10.871 2.35679 10.9016 2.36322C10.9313 2.36966 10.9619 2.35115 10.9683 2.32059C10.9965 2.1959 11.0906 2.04788 11.2113 1.90308C11.3987 1.67864 11.6521 1.46225 11.8484 1.34802C11.8749 1.33274 11.8838 1.29815 11.8685 1.2716C11.8516 1.24505 11.8178 1.2354 11.7913 1.25149Z",
    fill: "#F3F3F3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67017 4.25712C9.75527 4.20886 11.8404 4.16059 13.9255 4.11232C13.956 4.11152 13.981 4.08578 13.9802 4.05521C13.9794 4.02464 13.9536 3.9997 13.9231 4.00051C11.838 4.04877 9.75286 4.09704 7.66776 4.14531C7.63719 4.14611 7.61225 4.17185 7.61306 4.20242C7.61306 4.23299 7.6388 4.25793 7.67017 4.25712Z",
    fill: "#F3F3F3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1663 3.81496C14.2893 3.83427 15.4131 3.85357 16.5361 3.87368C16.5666 3.87449 16.5924 3.84955 16.5932 3.81898C16.594 3.78841 16.5691 3.76267 16.5385 3.76187C15.4155 3.74256 14.2917 3.72245 13.1687 3.70314C13.1381 3.70234 13.1124 3.72728 13.1116 3.75785C13.1108 3.78922 13.1357 3.81416 13.1663 3.81496Z",
    fill: "#F3F3F3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterest);
export default __webpack_public_path__ + "static/media/Interest.4fda97d69baabedc563e77d33cdab0d0.svg";
export { ForwardRef as ReactComponent };